<template>
  <div>
    <div class="link-button-box">
      <ButtonToLoginInfo />
      <ButtonToExamResult />
    </div>
    <div class="new-login-info">
      <h2 class="new-login-info-title">ログイン情報発行</h2>
      <b-form action="/api/new_login_info/" method="POST">
        <b-form-group
          id="input_group_applicant_name"
          label="受験者氏名"
          label-for="textarea_applicant_names"
        >
          <b-form-textarea
            id="textarea_applicant_names"
            type="text"
            name="applicantNames"
            v-model="applicantNames"
            :placeholder="'受験者氏名1\n受験者氏名2\n受験者氏名3'"
            rows="3"
            max-rows="20"
            required
          ></b-form-textarea>
        </b-form-group>

        <b-form-group id="input_group_exam" label="試験" label-for="input_exam">
          <b-form-select
            id="input_exam"
            name="examId"
            v-model="examSelected"
            :options="exams"
            required
          />
        </b-form-group>

        <b-button
          id="submit_button"
          type="submit"
          :variant="isSelected ? 'primary' : 'secondary'"
          :disabled="!isSelected"
        >
          発行
        </b-button>
      </b-form>
    </div>
  </div>
</template>

<script>
import ButtonToExamResult from '@/main/frontend/components/ButtonToExamResult.vue'
import ButtonToLoginInfo from '@/main/frontend/components/ButtonToLoginInfo.vue'

export default {
  components: {
    ButtonToExamResult,
    ButtonToLoginInfo
  },
  data() {
    return {
      applicantNames: '',
      examSelected: null,
      exams: [
        {value: null, text: '試験を選択して下さい'}
      ]
    }
  },
  mounted() {
    // 試験IDと試験名を API からjsonで取得し、exams に連結する
    this.$axios
      .get('/api/exam/view')
      .then((response) => (this.exams = this.exams.concat(response.data)))
  },
  computed: {
    isSelected() {
      return this.applicantNames && this.examSelected
    }
  }
}
</script>

<style scoped>
.new-login-info {
  left: 50%;
  max-width: 500px;
  position: fixed;
  text-align: center;
  top: 50%;
  transform: translateY(-50%) translateX(-50%);
  -webkit-transform: translateY(-50%) translateX(-50%);
}
.new-login-info-title {
    font-size: 20px;
}
.new-login-info .form-control {
  width: 330px;
}
</style>
